/**
 * Eigenbau: Anzeigetitel in Gewicht 200 — Tremors Überschriften beginnen bei 600.
 *
 * Der Entwurf setzt seine Titel dünn und groß: 54px auf „Heute", 46px auf den
 * Bereichen, 40px auf Detailseiten — durchgehend Gewicht 200. Das ist die
 * Gegenbewegung zur dichten Oberfläche darunter: Wo alles klein und mono ist,
 * trägt ein großer dünner Titel die Ruhe.
 *
 * Kein Tremor-Gegenstück. `Seitenkopf` im Haus setzt 22px in Gewicht 700 — die
 * genaue Umkehrung. Er bleibt für Masken, die keinen Anzeigetitel haben.
 *
 * Die Laufweite muss mit dem Grad mitgehen, sonst zerfällt der Titel: bei 54px
 * und Gewicht 200 stehen die Buchstaben ohne Minus sichtbar auseinander. Die
 * Werte sind die des Entwurfs, nicht geschätzt.
 */

import type { ReactNode } from "react";
import { cx } from "@/lib/utils";

const GRADE = {
  /** Detailseiten — „Eingangsprüfung Merge Request". */
  40: "text-[40px] tracking-[-0.034em] leading-[1.1]",
  /** Bereiche — „Auto Q&A", „Aufgaben". */
  46: "text-[46px] tracking-[-0.035em] leading-none",
  /** Die Übersicht — „Heute". */
  54: "text-[54px] tracking-anzeige leading-[0.95]",
} as const;

export function Titel({
  children,
  grad = 46,
  className,
}: {
  children: ReactNode;
  grad?: keyof typeof GRADE;
  className?: string;
}) {
  return (
    <h1
      className={cx(
        // `text-pretty` verhindert, dass ein langer Titel mit einem einzelnen
        // Wort in der zweiten Zeile endet. Der Entwurf setzt es selbst.
        "font-extralight text-pretty text-tinte",
        GRADE[grad],
        className,
      )}
    >
      {children}
    </h1>
  );
}
